'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';

import { useEffect } from 'react';
import { useState } from 'react';
import { Pagination } from 'react-bootstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PlutoMenu from './PlutoMenu';
import PaginationPluto from './Pagination';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';

function PlutoOfferDataTotal() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    useEffect(() => {
        socket.on('response_get_admin_offersdata', (data) => {
            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 10))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)

        })
        socket.emit('getOffersDataAdmin', {
            offers_like: username,
            page,
        })
    }, [])
    useEffect(() => {
        socket.on('reTakePendingData', () => {
            socket.emit('getOffersDataAdmin', {
                offers_like: username,

                page,
            })
        })
    }, [])
    return (
        <SkeletonTheme baseColor="#0d131c" highlightColor="#111923">

            <div class="modal-body" style={{ color: 'var(--text-primary)' }}>
                <div className="user-details-stats">

                    {userProfile.withdrawalsLength != undefined ?
                        <div className="card">
                            <p>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p>Count offers</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}


                </div>
                <div style={{ overflow: 'auto', margin: '0 auto', padding: '20px', marginBottom: '20px', background: 'var(--accent-1)' }}>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 'bold' }}>Suspect Offers</p>
                    <div className="input-container">
                        <input style={{ borderRadius: '5px', background: 'transparent', marginBottom: '5px', color: '#fff', fontSize: '12px', padding: '5px' }} onChange={(e) => {
                            setUsername(e.currentTarget.value)
                            setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

                            socket.emit('getOffersDataAdmin', {
                                offers_like: e.currentTarget.value.toLowerCase(),
                                page: 1,
                            })

                        }} type="text" name="amount" placeholder="Search by offer name" autoComplete="off" />
                    </div>
                    <div style={{ fontWeight: 'bold' }}>
                        <div className="user-details-table-elements" >

                            <div style={{ minWidth: '250px', textAlign: 'left', color: 'var(--text-primary)' }} >Name</div>
                            <div style={{ minWidth: '50px' }}>Wall Name</div>
                            <div style={{ minWidth: '90px' }}>Completed Count</div>

                            <div style={{ minWidth: '50px' }}>Chargeback Count</div>
                            <div style={{ minWidth: '100px' }}>Chargeback in {monthNames[(getCurrentMonthNumber()<1?11:getCurrentMonthNumber()-1)]} </div>
                            <div style={{ minWidth: '100px' }}>Chargeback in {monthNames[(getCurrentMonthNumber()<1?11:getCurrentMonthNumber()-2)]} </div>
                            <div style={{ minWidth: '100px' }}>Chargeback in {monthNames[(getCurrentMonthNumber()<1?11:getCurrentMonthNumber()-3)]} </div>
                            <div style={{ minWidth: '100px' }}>Chargeback in {monthNames[(getCurrentMonthNumber()<1?11:getCurrentMonthNumber()-4)]} </div>
                            <div style={{ minWidth: '100px' }}>Chargeback in {monthNames[(getCurrentMonthNumber()<1?11:getCurrentMonthNumber()-5)]} </div>
                            <div style={{ minWidth: '100px' }}>Chargeback in {monthNames[(getCurrentMonthNumber()<1?11:getCurrentMonthNumber()-6)]} </div>


                        </div>
                    </div>

                    {earnings.map((earning, i) => {
                        return (
                            <div key={earning.id} className="user-details-table-elements admin-a" style={{ color: 'var(--text-primary)' }}>

                                <div style={{ minWidth: '250px', textAlign: 'left', color: 'var(--text-primary)' }} >{earning.name || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', }} >{earning.wall || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '90px', }} >{earning.count || <Skeleton style={{ width: '30px' }} />}</div>

                                <div style={{ minWidth: '50px', }} >{earning.chargebacks || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', }} >{earning.cbMonth1 || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', }} >{earning.cbMonth2 || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', }} >{earning.cbMonth3 || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', }} >{earning.cbMonth4 || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', }} >{earning.cbMonth5 || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', }} >{earning.cbMonth6 || <Skeleton style={{ width: '30px' }} />}</div>


                            </div>
                        )
                    })}
                </div>
                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    socket.emit('getOffersDataAdmin', {
                        offers_like: username,

                        page,
                    })
                }} />}

            </div>
            <div >
                <input onKeyDown={
                    (e) => {
                        if (e.key == 'Enter') {
                            canUsePagination(false)
                            setEarnings([0, 0, 0, 0, 0])
                            socket.emit('getOffersDataAdmin', {
                                offers_like: username,
                                page: document.getElementById('jumptototal').value,
                            })
                        }
                    }

                } type="number" id="jumptototal" style={{ background: 'gray', color: '#000' }} />
                <button onClick={() => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    socket.emit('getOffersDataAdmin', {
                        offers_like: username,
                        page: document.getElementById('jumptototal').value,
                    })
                }
                } style={{ color: '#fff', background: '#000' }}>Go to page</button>
            </div>
        </SkeletonTheme>
    )
}

export default PlutoOfferDataTotal

function getCurrentMonthNumber() {
    const currentDate = new Date(); // Get the current date
    const currentMonthNumber = currentDate.getMonth(); // getMonth() returns 0-based month index
    return currentMonthNumber;
}

// Example usage:
